/**
 * Tuiton Builder.
 */

import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';
import numeral from 'numeral';

import Dropdown from './inc/Dropdown';

if ( typeof tuitionData !== 'undefined' ) {
	( function( tuitionData ) {

		if ( ! document.getElementById( 'tuition-builder' ) ) {
			return
		}

		/**
		 * Functions
		 */

		let initialRender = true;

		const filterPrograms = ( collection, filters ) => {
			if ( ! filters ) {
				return collection;
			}

			if ( filters.program.value && collection.length ) {
				const program = filters.program.value;

				collection = collection.filter( item => tuitionData.relations.program_program[ program ].find( programId => item.ID === programId ) );
			}

			if ( filters.degree.value && collection.length ) {
				const degree = filters.degree.value;

				collection = collection.filter( item => tuitionData.relations.degree[ degree ].find( programId => item.ID === programId ) );
			}

			return collection;
		}

		const filtersEmpty = ( filters ) => {
			for ( var filter in filters ) {
				// If the string is not empty.
				if ( filters[ filter ].value.length > 0 ) {
					return false;
				}
			}

			return true;
		}

		const getFilteredPrograms = ( state ) => {
			const degreeFilter = state.filters.degree.value;

			if ( ! degreeFilter ) {
				// Return empty set when the degree filter is not set.
				return [];
			}

			return state.relations.degree[ degreeFilter ].map( id => { return state.programs[ id ] } )
		}

		const getSelectedProgram = ( state ) => {
			const degreeFilter = state.filters.degree.value;

			if ( ! degreeFilter && ! state.hash ) {
				// Return empty set when the degree filter is not set.
				return null;
			}

			const programFilter = state.filters.program.value;

			if ( ! programFilter && ! state.hash ) {
				// Return empty set when the degree filter is not set.
				return null;
			}

			if ( state.hash ) {
				return state.tuitionPages.find( item => item.program === parseInt( state.hash.substring( 1 ) ) )
			}

			return state.tuitionPages.find( item => item.program === parseInt( programFilter ) );
		}

		const getDefaultFilters = () => {
			if ( ! window.location.hash || '#' === window.location.hash ) {
				return {
					'degree': { value: '' },
					'program': { value: '' },
				};
			}

			if ( window.location.hash ) {
				return {
					'degree': { value: tuitionData.relations.program_relations[ window.location.hash.substring( 1 ) ].degree[0] },
					'program': { value: window.location.hash.substring( 1 ) }
				}
			}
		}

		/**
		 * App Components
		 */

		const createMoneyBox = (text, value, id) => element => {
			const box = document.createElement( 'div' );
			box.classList.add( 'money-box__container' );
			box.setAttribute( 'id', id );

			const boxTitle = document.createElement( 'div' );
			boxTitle.classList.add( 'money-box__titles' );
			boxTitle.classList.add( 'money-box__scholarships' );

			const boxValue = document.createElement( 'div' );
			boxValue.classList.add( 'money-box__dollars' );

			const boxText = document.createElement( 'h3' );
			boxText.classList.add( 'money-box__title' );

			const texts = document.createTextNode( text );
			const values = document.createTextNode( value );

			boxText.appendChild( texts );
			boxTitle.appendChild( boxText );
			boxValue.appendChild( values );
			box.appendChild( boxTitle );
			box.appendChild( boxValue );

			return box;
		}

		const entities = new Entities();

		const dangerouslySetInnerHTML = (html, programID) => element => {
			element.innerHTML = html;

			// Handle JS for components.
			let scholarships, school;

			if ( tuitionData.programs[ programID ] && tuitionData.programs[ programID ].scholarship_display ) {
				if ( tuitionData.relations.program_relations[ programID ] && tuitionData.relations.program_relations[ programID ].program_school ) {
					school = tuitionData.relations.program_relations[ programID ].program_school;

					if ( tuitionData.programs[ programID ].scholarships && tuitionData.programs[ programID ].scholarships.length ) {
						scholarships = tuitionData.programs[ programID ].scholarships.map( scholarship => ( {
							'scholarship_name': scholarship.program_scholarship_name,
							'scholarship_value': scholarship.program_scholarship_value
						} ) );
					}

					if ( ! scholarships && tuitionData.scholarships[ school ] && tuitionData.scholarships[ school ].length ) {
						scholarships = tuitionData.scholarships[ school ];
					}
				}
			}

			const $moneyBox = $( '.money-box' ).first();

			if ( scholarships && scholarships.length ) {
				const box = document.createElement( 'div' );
				box.classList.add( 'money-box__container' );

				const boxTitle = document.createElement( 'div' );
				boxTitle.classList.add( 'money-box__titles' );
				boxTitle.classList.add( 'money-box__scholarships' );

				const boxValue = document.createElement( 'div' );
				boxValue.classList.add( 'money-box__dollars' );
				boxValue.classList.add( 'money-box__scholarship-value' );
				boxValue.setAttribute( 'id', 'total-percent' );

				const boxText = document.createElement( 'h3' );
				boxText.classList.add( 'money-box__title' );

				const texts = document.createTextNode( 'Scholarship or Fellowship Awarded' );

				boxText.appendChild( texts );
				boxTitle.appendChild( boxText );
				box.appendChild( boxTitle );
				box.appendChild( boxValue );

				$moneyBox.children( '.container' ).append( box );

				const scholarshipContainer = document.createElement( 'div' );
				scholarshipContainer.classList.add( 'scholarship-container' );

				const dropdownIcon = document.createElement( 'span' );
				dropdownIcon.classList.add( 'icon-chev-down' );
				dropdownIcon.classList.add( 'icon' );
				dropdownIcon.setAttribute( 'aria-hidden', true );

				const scholarship = document.createElement( 'select' );
				const option      = document.createElement( 'option' );
				const optionText  = document.createTextNode( 'Select Scholarship' );

				option.value = 0;
				option.appendChild( optionText );

				scholarship.appendChild( option );

				scholarshipContainer.appendChild( scholarship );
				scholarshipContainer.appendChild( dropdownIcon );

				scholarships.forEach( ( schol ) => {
					const el = document.createElement( 'option' );
					const text = document.createTextNode( schol.scholarship_name );

					el.value = schol.scholarship_value;
					el.appendChild( text );

					scholarship.appendChild( el );
				} );

				boxTitle.appendChild( scholarshipContainer );

				const dollars = Array.from( document.querySelector( '.money-box' ).querySelectorAll( '.money-box__dollars' ) );
				const values = dollars.map( x => x.innerText );

				scholarship.addEventListener( 'change', function( e ) {
					const existingTotal   = document.getElementById( 'total-box' );
					const existingPercent = document.getElementById( 'total-percent' );

					// Remove already existant total.
					if ( existingTotal ) {
						existingTotal.parentNode.removeChild( existingTotal );
					}

					if ( existingPercent ) {
						existingPercent.innerText = '';
					}

					const target = e.target;

					const percentage = ( ( 100 - target.value ) / 100 );

					dollars.slice( 0, 1 ).forEach( ( dollar, index ) => {
						const amount = numeral( values[ index ] );

						amount.multiply( percentage );

						dollar.textContent = amount.format( '$0,0' );
					} );

					let finalCost = numeral( values[ 1 ] );

					finalCost.multiply( percentage );

					const totalBox = target.value > 0 ? createMoneyBox( 'Total Program Cost', finalCost.format( '$0,0' ), 'total-box' ) : null;
					const percentageNode = target.value > 0 ? document.createTextNode( '-' + target.value + '%' ) : document.createTextNode( '' );

					if ( target.value > 0 ) {
						$moneyBox.children( '.container' ).append( totalBox );
						boxValue.appendChild( percentageNode );
					}
				} );
			}

			if ( initialRender && window.location.hash ) {
				initialRender = false;
			} else {
				$('.accordion').accordion();
			}
		}

		const defaultFilters = getDefaultFilters();

		const state = {
			programs: tuitionData.programs,
			degrees: tuitionData.degrees,
			tuitionPages: tuitionData.tuition_pages,
			relations: tuitionData.relations,
			scholarships: tuitionData.scholarships,

			filteredPrograms: [],
			hash: window.location.hash,
			filters: defaultFilters
		};

		const actions = {
			updateFilters: ( filter ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					state.filters,
					{
						[ filter.key ]: Object.assign(
							{},
							state.filters[ filter.key ],
							{ value: filter.value }
						)
					}
				);

				return nextState;
			},
			clearFilters: () => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					{
						'program': { value: '' },
						'degree': { value: '' },
					}
				);

				return nextState;
			},
			filterPrograms: () => ( state ) => {
				const degreeFilter = state.filters.degree.value;

				if ( ! degreeFilter ) {
					// Return empty set when the degree filter is not set.
					return [];
				}

				return Object.assign(
					{},
					state,
					{
						filteredPrograms: state.relations.degree[ degreeFilter ].map( id => { return state.programs[ id ] } )
					}
				)
			},
			setHash: ( hash ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.hash = hash;

				return nextState;
			}
		};

		const view = ( state, actions ) => {
			const selectedProgram = getSelectedProgram( state );

			return (
				<div class="tuition-builder__container">
					<Filters key="filters" actions={ actions } state={ state } />
					{ selectedProgram && <SelectedProgram key="selected-program" selectedProgram={ selectedProgram } /> }
				</div>
			)
		}

		const Filters = ( { actions, state } ) => {
			const updateFilters = actions.updateFilters;
			const filters = state.filters;
			// Get non empty degrees.
			const degrees = state.degrees.filter( degree => {
				if ( state.relations.degree[ degree.term_id ] && state.relations.degree[ degree.term_id ].length ) {
					return true;
				}

				return false;
			} );
			const programs = getFilteredPrograms( state );

			// const ClearFilters = ! filtersEmpty( state.filters ) ? <button onclick={ actions.clearFilters } class="reset clear-filters"><i class="icon-close clear-filters__icon"></i><span class="clear-filters__text">CLEAR FILTERS</span></button> : null;

			return (
				<div class="tuition-builder__filters-container">
					<div class="tuition-builder__filters">
						<DegreeFilter degrees={ degrees } actions={ actions } filters={ filters } />
						<ProgramFilter tuitionPages={ state.tuitionPages } programs={ programs } actions={ actions } filters={ filters } />
					</div>
				</div>
			);
		}

		const DegreeFilter = ( { actions, degrees, filters } ) => {
			const degreesOrder = {
				"Master's": 1,
				'Masters': 1,
				'Certificate': 2,
				'Dual Degree': 3,
				'Doctorate': 4
			}
			degrees = degrees.map( ( degree ) => {
				if ( degree.term_id === filters.degree.value ) {
					degree.selected = true;
				} else {
					degree.selected = false;
				}

				return degree;
			} ).sort( ( a, b ) => {
				return degreesOrder[a.name] - degreesOrder[b.name];
			} )

			const update = ( event, id, name ) => {
				if ( filters['degree'].value === id ) {
					return;
				}

				const { updateFilters } = actions;

				window.location.hash = '';
				actions.setHash( '' );
				updateFilters( { key: 'degree', value: id } );
				actions.updateFilters( { key: 'program', value: '' } );
				actions.filterPrograms();
			}

			let header = "Filter by degree";
			let matchedDegreeId = undefined;

			if ( window.location.hash && window.location.hash !== '#' ) {
				matchedDegreeId = tuitionData.relations.program_relations[ window.location.hash.substring( 1 ) ].degree[0];
			}

			if ( matchedDegreeId ) {
				const degree = tuitionData.degrees.find( degree => degree.term_id === matchedDegreeId );
				header = degree.name;
			}

			if ( degrees ) {
				return <Dropdown list={ degrees } header="Filter by degree" onClickFunc={ update } selectedItem={ header } />
			}

			return null;
		}

		const ProgramFilter = ( { actions, programs, filters, tuitionPages } ) => {
			programs = programs.filter( program => program ).map( ( program ) => {
				if ( program.ID === filters.program.value ) {
					program.selected = true;
				} else {
					program.selected = false;
				}

				return program;
			} ).map( program => Object.assign( program, { 'name': program.display_title, id: program.ID } ) ).sort( ( a, b ) => { return a.name.localeCompare( b.name ) } );

			const update = ( event, id, name ) => {
				if ( filters['program'].value === id ) {
					return;
				}

				const { updateFilters } = actions;

				window.location.hash = '#' + id;
				actions.setHash( '#' + id );
				updateFilters( { key: 'program', value: id } );
			}

			let header = "Filter by program";
			const matchedProgram = tuitionPages.find( item => item.program === parseInt( filters.program.value ) );

			if ( matchedProgram ) {
				header = matchedProgram.display_title;
			}

			if ( programs.length ) {
				return <Dropdown list={ programs } header="Filter by program" onClickFunc={ update } selectedItem={ header } />
			}

			return <Dropdown list={ programs } disabled header="Filter by program" onClickFunc={ update } />;
		}

		const SelectedProgram = ( { selectedProgram } ) => {
			return (
				<div class="tuition-program">
					<h2 class="tution-program__title">{ selectedProgram['post_title'] }</h2>
					<div oncreate={ dangerouslySetInnerHTML( selectedProgram.content, selectedProgram.program ) } onupdate={ dangerouslySetInnerHTML( selectedProgram.content, selectedProgram.program ) }></div>
				</div>
			);
		}

		const App = app( state, actions, view, document.getElementById( 'tuition-builder' ) )

	} ( tuitionData ) );
}



// WEBPACK FOOTER //
// ./assets/js/tuition-builder.js